<template>
    <div>
        <a href="#"
            v-on:click="showModal"
            :class="clickStyle"
        >
            {{ clickText }}
        </a>
        <div v-if="showConfirm" class="modal-mask" @click="closeModal">
            <div class="iframe-container" @click.stop>
                <div class="iframe" v-html="iframe"></div>
                <span class="btn btn-default pull-right margin-top-5" @click="closeModal">cancel</span>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    props: ['iframe', 'clickText', 'clickStyle'],
    data() {
        return {
            showConfirm: false
        }
    },
    methods: {
        showModal() {
            event.preventDefault()
            this.showConfirm = true
        },
        closeModal() {
            this.showConfirm = false
        },
    }

}
</script>
